// Sorting students / teachers the way a school reads them (same rules as Nodejs src/ar_sort.js, which
// sorts /user/students/list on the server before the page is cut):
// names alphabetically with Arabic spelling variants treated alike (أ إ آ ا, ة ه, ى ي, no tashkeel),
// and classes in school order — kindergarten, primary, intermediate, secondary, then first, second,
// third... (alphabetically «الثالث» would come before «الثاني») — then the classroom (2 before 10).
//   sort_rows(list, mode)  mode: name_asc | name_desc | class_asc | class_desc; anything else → list unchanged

function norm(s){
    return (s == null ? '' : String(s))
        .replace(/[ً-ٰٟـ]/g, '')
        .replace(/[أإآٱ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
        .replace(/[٠-٩]/g, function(d){ return '٠١٢٣٤٥٦٧٨٩'.indexOf(d); })
        .toLowerCase().replace(/\s+/g, ' ').trim();
}

function cmp_text(a, b){
    var x = norm(a), y = norm(b);
    if(x < y) return -1;
    if(x > y) return 1;
    a = a == null ? '' : String(a); b = b == null ? '' : String(b);
    return a < b ? -1 : a > b ? 1 : 0;
}

// numbers by value (2 before 10), otherwise text
function cmp_natural(a, b){
    var x = norm(a), y = norm(b);
    var nx = /^\d+$/.test(x) ? Number(x) : NaN, ny = /^\d+$/.test(y) ? Number(y) : NaN;
    if(!isNaN(nx) && !isNaN(ny) && nx != ny) return nx - ny;
    return cmp_text(a, b);
}

// masculine and feminine (الأول / الأولى، الثاني / الثانية ...), after spelling is normalised
var ORDINALS = [
    [/(ال)?(حادي|حاديه) عشر/, 11], [/(ال)?(ثاني|ثانيه) عشر/, 12],
].concat([['اول', 'اولي'], ['ثاني', 'ثانيه'], ['ثالث', 'ثالثه'], ['رابع', 'رابعه'], ['خامس', 'خامسه'],
    ['سادس', 'سادسه'], ['سابع', 'سابعه'], ['ثامن', 'ثامنه'], ['تاسع', 'تاسعه'], ['عاشر', 'عاشره']]
    .map(function(w, i){ return [new RegExp('(^| )(ال)?(' + w.join('|') + ')( |$)'), i + 1]; }));

// [stage, grade] of a class name: stage 0 روضة/تمهيدي, 1 ابتدائي, 2 متوسط, 3 ثانوي, 4 unknown
function grade_of(classname){
    var s = norm(classname);
    var stage = /روضه|تمهيدي|kg/.test(s) ? 0 : /ابتدا/.test(s) ? 1 : /متوسط/.test(s) ? 2 : /ثانو/.test(s) ? 3 : 4;
    var grade = 99;
    for(var i = 0; i < ORDINALS.length; i++){
        if(ORDINALS[i][0].test(s)){ grade = ORDINALS[i][1]; break; }
    }
    if(grade == 99){
        var d = s.match(/\d+/);
        if(d) grade = Number(d[0]);
    }
    return [stage, grade];
}

function cmp_class(a, b){
    var ga = grade_of(a.classname), gb = grade_of(b.classname);
    return (ga[0] - gb[0]) || (ga[1] - gb[1]) || cmp_text(a.classname, b.classname) || cmp_natural(a.classroom, b.classroom);
}

var MODES = ['name_asc', 'name_desc', 'class_asc', 'class_desc'];

function sort_rows(list, mode){
    if(!Array.isArray(list) || MODES.indexOf(mode) < 0) return list;
    var rows = list.slice();
    var by_name = function(a, b){ return cmp_text(a && a.name, b && b.name); };
    var f = {
        name_asc: by_name,
        name_desc: function(a, b){ return -by_name(a, b); },
        class_asc: function(a, b){ return cmp_class(a || {}, b || {}) || by_name(a, b); },
        class_desc: function(a, b){ return -cmp_class(a || {}, b || {}) || by_name(a, b); },
    }[mode];
    // stable: equal rows keep their original order
    return rows.map(function(r, i){ return [r, i]; })
        .sort(function(x, y){ return f(x[0], y[0]) || (x[1] - y[1]); })
        .map(function(x){ return x[0]; });
}

// The choices of the «ترتيب» select (views/components/SortSelect.vue).
var CHOICES = [
    { value: '', text: 'الترتيب الافتراضي' },
    { value: 'name_asc', text: 'الاسم (أ ← ي)' },
    { value: 'name_desc', text: 'الاسم (ي ← أ)' },
    { value: 'class_asc', text: 'الصف والفصل (تصاعدي)' },
    { value: 'class_desc', text: 'الصف والفصل (تنازلي)' },
];

export { sort_rows, norm, cmp_text, cmp_natural, grade_of, MODES, CHOICES };
